"use client";

import { Sun, BarChart3 } from "lucide-react";
import { HOME_CONTEXT_PER_PERSONA } from "@petci/shared-ui";
import { formatCurrency, formatKwh } from "@/lib/format";
import { useActivePersona } from "@/lib/persona";
import { useT } from "@/lib/locale";

export function HomeContextCard() {
  const persona = useActivePersona();
  const ctx = HOME_CONTEXT_PER_PERSONA[persona.id];
  const t = useT();

  if (!ctx) return null;

  if (ctx.kind === "solar") {
    return (
      <div className="card-surface space-y-2">
        <div className="flex items-center gap-2">
          <span className="w-7 h-7 rounded-lg bg-brand-primary/10 flex items-center justify-center">
            <Sun size={14} className="text-brand-primary-text" aria-hidden />
          </span>
          <h2 className="text-xs font-semibold text-neutral-700 uppercase tracking-wider">
            {t("home.solarThisMonth")}
          </h2>
        </div>
        <p className="font-display font-bold text-brand-primary-text text-xl">
          {formatCurrency(ctx.creditUSD)}
        </p>
        <div className="space-y-0.5">
          <p className="text-xs text-neutral-500">
            {t("home.solarExportedOffset", { kwh: formatKwh(ctx.exportKWh), pct: ctx.offsetPct })}
          </p>
          <p className="text-xs text-neutral-500">
            {t("home.solarCapacityPanels", { kw: ctx.capacityKW, panels: ctx.panels })}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="card-surface space-y-2">
      <div className="flex items-center gap-2">
        <span className="w-7 h-7 rounded-lg bg-brand-primary/10 flex items-center justify-center">
          <BarChart3 size={14} className="text-brand-primary-text" aria-hidden />
        </span>
        <h2 className="text-xs font-semibold text-neutral-700 uppercase tracking-wider">
          {t("home.usageThisMonth")}
        </h2>
      </div>
      <p className="font-display font-bold text-brand-primary-text text-xl">
        {formatKwh(ctx.usageKWh)}
      </p>
      <div className="space-y-0.5">
        <p className="text-xs text-neutral-500">
          {t("home.usageVsPriorCycle", { sign: ctx.trendPct > 0 ? "+" : "", pct: ctx.trendPct })}
        </p>
        <p className="text-xs text-neutral-500">
          {ctx.highlightFigure} {t(ctx.highlightLabelKey)}
        </p>
      </div>
    </div>
  );
}
